(function(){'use strict';
  var endpoint='https://lzcpiphfoscznxfxzqqz.supabase.co/functions/v1/prelaunch-public-status';
  var root=document.documentElement;
  var timer=0;

  function isPublicHome(){
    var p=(window.location.pathname||'/').replace(/\/+$/,'')||'/';
    return p==='/'||p==='/index';
  }

  function revealSite(){
    var gate=document.getElementById('pf-prelaunch-gate');
    root.classList.remove('pf-prelaunch-pending','pf-prelaunch-active');
    if(gate)gate.hidden=true;
  }

  function showGate(){
    if(!isPublicHome())return;
    var gate=document.getElementById('pf-prelaunch-gate');
    root.classList.remove('pf-prelaunch-pending');
    root.classList.add('pf-prelaunch-active');
    if(gate)gate.hidden=false;
  }

  function applyState(state){
    state=String(state||'PRE_LAUNCH').toUpperCase();
    if(state==='LIVE'||window.__PROFIND_QA_PRELAUNCH_ACCESS===true){
      revealSite();
      if(state==='LIVE'&&timer){window.clearInterval(timer);timer=0;}
    }else{
      showGate();
    }
  }

  function checkLaunchState(){
    if(!isPublicHome()){
      if(timer){window.clearInterval(timer);timer=0;}
      return;
    }
    var controller=window.AbortController?new AbortController():null;
    var timeout=window.setTimeout(function(){if(controller)controller.abort();},3500);
    fetch(endpoint,{method:'GET',mode:'cors',cache:'no-store',signal:controller?controller.signal:undefined})
      .then(function(r){if(!r.ok)throw new Error('ProFind launch status '+r.status);return r.json();})
      .then(function(data){
        window.clearTimeout(timeout);
        applyState(data.platform_state);
      })
      .catch(function(){window.clearTimeout(timeout);});
  }

  window.addEventListener('profind:prelaunch-access',function(event){
    var detail=event&&event.detail||{};
    if(detail.state==='LIVE'||detail.allowed===true)revealSite();
    else if(detail.state==='PRE_LAUNCH')showGate();
  });

  if(window.__PROFIND_QA_PRELAUNCH_ACCESS===true)revealSite();
  checkLaunchState();
  timer=window.setInterval(checkLaunchState,30000);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)checkLaunchState();});
})();
